import { atom } from 'jotai';

export const currentComponentAtom = atom<string | null>(null);
